const fmt = (n) => Number(n || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
const fmtN = (n) => Number(n || 0).toLocaleString('en-US');

const ExternalIcon = () => (
  <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
    <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"/>
    <polyline points="15 3 21 3 21 9"/>
    <line x1="10" y1="14" x2="21" y2="3"/>
  </svg>
);

export default function AppCard({ app, stats }) {
  const isActive = stats.thisMonth > 0;

  const domainUrl = (() => {
    const d = app.homepage || app.redirect_uri;
    if (!d) return null;
    return d.startsWith('http') ? d : `https://${d}`;
  })();

  const domainLabel = app.homepage || app.redirect_uri || null;
  const avatarLetter = (domainLabel || `${app.app_id}`).replace(/^https?:\/\//, '').charAt(0).toUpperCase();

  const trend = stats.lastMonth > 0
    ? ((stats.thisMonth - stats.lastMonth) / stats.lastMonth * 100).toFixed(1)
    : null;
  const trendUp = trend !== null && parseFloat(trend) >= 0;

  const shareColor = (() => {
    const s = parseFloat(stats.sharePercent);
    if (s >= 50) return 'var(--series-3)';
    if (s >= 25) return 'var(--series-1)';
    if (s >= 10) return 'var(--series-4)';
    return 'var(--muted)';
  })();

  return (
    <div className="aac" style={{ '--ac-status': isActive ? 'var(--good)' : 'var(--line-strong)' }}>
      <div className="aac-accent" />
      <div className="aac-body">
        <div className="aac-header">
          <div className="aac-id-row">
            <span className="aac-avatar">{avatarLetter}</span>
            <div className="aac-id-col">
              <span className="aac-num">App #{app.app_id}</span>
              {domainUrl ? (
                <a className="aac-domain-link" href={domainUrl} target="_blank" rel="noopener noreferrer">
                  {domainLabel}
                  <ExternalIcon />
                </a>
              ) : (
                <span className="aac-no-domain">No domain</span>
              )}
            </div>
          </div>
          <span className={`aac-status ${isActive ? 'aac-status--on' : 'aac-status--off'}`}>
            {isActive ? 'Active' : 'Inactive'}
          </span>
        </div>

        <div className="aac-primary">
          <span className="aac-lbl">This Month</span>
          <div className="aac-val-row">
            <span className="aac-val aac-val--lg">${fmt(stats.thisMonth)}</span>
            {trend !== null && (
              <span className={`aac-trend ${trendUp ? 'aac-trend--up' : 'aac-trend--down'}`}>
                {trendUp ? '+' : ''}{trend}%
              </span>
            )}
          </div>
        </div>

        <div className="aac-stats">
          <div className="aac-stat">
            <span className="aac-lbl">Today</span>
            <span className="aac-val">${fmt(stats.today)}</span>
          </div>
          <div className="aac-stat">
            <span className="aac-lbl">Last Month</span>
            <span className="aac-val aac-val--muted">${fmt(stats.lastMonth)}</span>
          </div>
          <div className="aac-stat">
            <span className="aac-lbl">Contracts</span>
            <span className="aac-val">{fmtN(stats.transactions)}</span>
          </div>
          {stats.clients > 0 && (
            <div className="aac-stat">
              <span className="aac-lbl">Clients</span>
              <span className="aac-val">{fmtN(stats.clients)}</span>
            </div>
          )}
        </div>

        <div className="aac-share">
          <div className="aac-share-top">
            <span className="aac-lbl">Share of total</span>
            <span className="aac-share-pct">{stats.sharePercent}%</span>
          </div>
          <div className="aac-bar-track">
            <div className="aac-bar-fill" style={{ width: `${Math.min(stats.sharePercent, 100)}%`, background: shareColor }} />
          </div>
        </div>
      </div>
    </div>
  );
}
